"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2271],{

/***/ 52271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useContentLoaded__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64523);





var GoogleTagManager = function() {
    var contentLoaded = (0,_hooks_useContentLoaded__WEBPACK_IMPORTED_MODULE_4__/* .useContentLoaded */ .S)();
    if (!contentLoaded) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
            __html: "\n          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});\n          var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';\n          j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;\n          f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','".concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_2__.GA_TRACKING_ID, "');\n        ")
        }
    });
};
/* harmony default export */ __webpack_exports__["default"] = (GoogleTagManager);


/***/ }),

/***/ 64523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useContentLoaded; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var domLoadedEvents = [
    "DOMContentLoaded",
    "load"
];
var userInteractionEvents = [
    "mousemove",
    "scroll",
    "keydown",
    "keypress",
    "keyup",
    "mouseenter", 
];
var useContentLoaded = function() {
    var loadedAndInteractive =  true && window.loadedAndInteractive === true;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(loadedAndInteractive), domLoaded = ref[0], setDomLoaded = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(loadedAndInteractive), userInteracted = ref1[0], setUserInteracted = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!domLoaded && !loadedAndInteractive) {
            var domLoaderWatcher = function() {
                return setDomLoaded(true);
            };
            domLoadedEvents.forEach(function(event) {
                return window.addEventListener(event, domLoaderWatcher, {
                    capture: true,
                    once: true
                });
            });
            return function() {
                return domLoadedEvents.forEach(function(event) {
                    return window.removeEventListener(event, domLoaderWatcher);
                });
            };
        }
        return function() {};
    }, [
        domLoaded,
        loadedAndInteractive
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!userInteracted && !loadedAndInteractive) {
            var userInteractionWatcher = function() {
                return setUserInteracted(true);
            };
            userInteractionEvents.forEach(function(event) {
                return window.addEventListener(event, userInteractionWatcher, {
                    capture: true,
                    once: true
                });
            });
            try {
                var iframes = document.getElementsByTagName("iframe");
                userInteractionEvents.forEach(function(event) {
                    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(iframes).forEach(function(iframe) {
                        iframe.addEventListener(event, userInteractionWatcher, {
                            capture: true,
                            once: true
                        });
                    });
                });
            } catch (e) {
            // Fail silently
            }
            return function() {
                userInteractionEvents.forEach(function(event) {
                    return window.removeEventListener(event, userInteractionWatcher);
                });
                try {
                    var iframes = document.getElementsByTagName("iframe");
                    userInteractionEvents.forEach(function(event) {
                        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(iframes).forEach(function(iframe) {
                            iframe.removeEventListener(event, userInteractionWatcher);
                        });
                    });
                } catch (e) {
                // Fail silently
                }
            };
        }
        return function() {};
    }, [
        userInteracted,
        loadedAndInteractive
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (domLoaded && userInteracted && !window.loadedAndInteractive) {
            window.loadedAndInteractive = true;
            window.dispatchEvent(new Event("loadedAndInteractive"));
        }
    }, [
        domLoaded,
        userInteracted
    ]);
    return domLoaded && userInteracted || loadedAndInteractive;
};
/* harmony default export */ __webpack_exports__["Z"] = (useContentLoaded);


/***/ })

}]);